import { render, staticRenderFns } from "./ProductsManagement.vue?vue&type=template&id=3d7619e8"
import script from "./ProductsManagement.vue?vue&type=script&lang=js"
export * from "./ProductsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports